/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import template from "templates/modules/sale_hub_filter_tool_search_results";

export default baustein.register("sale-hub-filter-tool-search-results", {
    template,

    getInitialRenderContext() {
        return {
            sale_hub_filter_tool_search_results: {
                designers: []
            }
        };
    },

    show() {
        this.el.classList.remove("hidden");
    },

    hide() {
        this.el.classList.add("hidden");
    }
});

